import React from "react";
import styles from "./MainPages.module.css";
import { useNavigate } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <main className={styles.notfoundPage} data-testid="not-found-page">
      <section className={styles.notfoundContainer}>
        <div className={styles.notfoundBadge}>Error 404</div>

        <div className={styles.notfoundCode}>404</div>

        <h1 className={styles.notfoundTitle}>Page not found</h1>

        <p className={styles.notfoundSubtitle}>
          The page you&apos;re looking for doesn&apos;t exist, was moved, or the
          URL is incorrect. Check the link or head back to the homepage.
        </p>

        <div className={styles.notfoundActions}>
          <button
            type="button"
            className={styles.notfoundHomeButton}
            onClick={() => navigate("/", { replace: true })}
            data-testid="not-found-home-btn"
          >
            Go back home
          </button>

          <button
            type="button"
            className={styles.notfoundSecondaryButton}
            onClick={() => navigate(-1)}
            data-testid="not-found-back-btn"
          >
            Go to previous page
          </button>
        </div>
      </section>
    </main>
  );
};

export default NotFoundPage;
